/**
 * Firestore Service
 * PROTEGE QV Lecture+ — Generic Firestore helpers
 */

import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from './firebase.js';

/**
 * Save a document to a Firestore collection with a server timestamp.
 * @param {string} collectionName
 * @param {Record<string, unknown>} data
 * @returns {Promise<import('firebase/firestore').DocumentReference>}
 */
export const saveDocument = async (collectionName, data) => {
  return addDoc(collection(db, collectionName), {
    ...data,
    createdAt: serverTimestamp(),
  });
};
